export default __webpack_public_path__ + "static/media/lodash.9dfb04d9.svg";